import { AText } from '@alf/uikit';
import { useDeviceStore } from '@namespace/device';
import { useI18n } from '@namespace/i18n';
import { useThemeComponents } from '@namespace/themes';
import VerificationStatusNotification from '../VerificationStatusNotification';

import styles from './index.module.css';

const VerifiedUserToast = ({ onClose }) => {
  const { t } = useI18n();
  const { isDesktop } = useDeviceStore();
  const text = t('verifiedUser.notification');
  const { VerifiedStatusNotification: PartnerVerifiedStatusNotification } =
    useThemeComponents();

  const message = isDesktop ? (
    text
  ) : (
    <AText className={styles.text} size="l" align="center">
      {t('web.notification.verification.verified.info')}
    </AText>
  );

  if (PartnerVerifiedStatusNotification) {
    return <PartnerVerifiedStatusNotification onClose={onClose} />;
  }

  return (
    <VerificationStatusNotification
      onClose={onClose}
      message={message}
      customClassName={styles.toast}
    />
  );
};

export default VerifiedUserToast;
